import { Router as RouterProps, withRouter } from "next/router"
import React from "react"
import { compose } from "react-apollo"
import withAccountAndLocationSlug from "../../components/hocs/withAccountAndLocationSlug"
import { getMuiTheme } from "../../components/setup/muiTheme"
import { MerchantInfoQueryComponent } from "../../graphql/generated-types"
import { getLocationInfo, getLocationSettings } from "../../utils/data"
import { ThemeProvider } from "@material-ui/styles"
import chroma from "chroma-js"
import { getRouterQuery } from "../../utils/router"

interface Props {
    displayPreloading: boolean
    children: React.ReactNode
    router: RouterProps
}

class MuiThemeProviderWrapper extends React.PureComponent<Props> {
    render() {
        if (this.props.displayPreloading || !getRouterQuery(this.props.router, "accountSlug")) {
            return <ThemeProvider theme={getMuiTheme()}>{this.props.children}</ThemeProvider>
        } else {
            return (
                <MerchantInfoQueryComponent fetchPolicy="cache-and-network">
                    {({ error, data }) => {
                        const noData = !data || !data.merchantInfo || error
                        const locationInfo =
                            !noData &&
                            getLocationInfo(data.merchantInfo, getRouterQuery(this.props.router, "locationSlug"))
                        const locationSettings = locationInfo && getLocationSettings(locationInfo)

                        const theme = locationSettings ? getMuiTheme(locationSettings.primaryColor) : getMuiTheme()

                        return (
                            <div>
                                <ThemeProvider theme={theme}>{this.props.children}</ThemeProvider>
                                {Boolean(locationSettings && locationSettings.primaryColor) && (
                                    <style jsx={true} global={true}>{`
                                        #nprogress .bar {
                                            background: ${chroma(locationSettings.primaryColor).hex()};
                                        }
                                    `}</style>
                                )}
                            </div>
                        )
                    }}
                </MerchantInfoQueryComponent>
            )
        }
    }
}

const composed = compose(
    withRouter,
    withAccountAndLocationSlug
)

export default composed(MuiThemeProviderWrapper)
